module.exports = __webpack_public_path__ + "static/media/logo.ca6abaa3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 50
// module chunks = 0